"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

var _Radio = _interopRequireDefault(require("../../Radio"));

var _OptionImage = _interopRequireDefault(require("./OptionImage"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tflex: 1 1 auto;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tlabel {\n\t\tmargin: ", " 0;\n\t}\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tlabel {\n\t\tmargin: ", " 0;\n\t}\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\tcolor: ", ";\n\tfont-size: 14px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\tpadding: ", " ", ";\n\tmargin: 0;\n\tlist-style: none;\n\toutline: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\t", ";\n\t", ";\n\tmax-width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: not-allowed;\n\tbackground-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tline-height: 1.2;\n\tword-break: break-all;\n\n\tdiv {\n\t\tmargin: ", " 0;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Label = _styledComponents.default.span(_templateObject(), _spacing.default.s1);

Label.displayName = 'Label';
var disabledCSS = (0, _styledComponents.css)(_templateObject2(), _colors.default.greyLight);

var Container = _styledComponents.default.li(_templateObject3(), _spacing.default.s1, _spacing.default.s2, function (props) {
  return props.disabled && disabledCSS;
}, function (props) {
  return props.highlight && "background: " + _colors.default.primaryLighter;
});

Container.displayName = 'Container';

var SecondaryLabel = _styledComponents.default.small(_templateObject4(), _colors.default.greyDark);

SecondaryLabel.displayName = 'SecondaryLabel';
var SCheckbox = (0, _styledComponents.default)(_Checkbox.default)(_templateObject5(), _spacing.default.s1);
SCheckbox.displayName = 'Checkbox';
var SRadio = (0, _styledComponents.default)(_Radio.default)(_templateObject6(), _spacing.default.s1);
SRadio.displayName = 'Radio';

var Text = _styledComponents.default.div(_templateObject7());

Text.displayName = 'Text';

var Option = _react.default.forwardRef(function (_ref, ref) {
  var isMultiSelect = _ref.isMultiSelect,
      selectedItems = _ref.selectedItems,
      label = _ref.label,
      secondaryLabel = _ref.secondaryLabel,
      disabled = _ref.disabled,
      Icon = _ref.Icon,
      image = _ref.image,
      density = _ref.density,
      props = _objectWithoutPropertiesLoose(_ref, ["isMultiSelect", "selectedItems", "label", "secondaryLabel", "disabled", "Icon", "image", "density"]);

  var InputType = isMultiSelect ? SCheckbox : SRadio;
  return _react.default.createElement(Container, _extends({
    disabled: disabled,
    ref: ref
  }, props), _react.default.createElement(_OptionImage.default, {
    Icon: Icon,
    image: image,
    density: density
  }), _react.default.createElement(Text, null, _react.default.createElement(Label, null, _react.default.createElement("div", null, label), secondaryLabel && _react.default.createElement(SecondaryLabel, null, secondaryLabel))), _react.default.createElement("div", null, props.onClick && !disabled && _react.default.createElement(InputType, {
    readOnly: true,
    checked: selectedItems.includes(props.id),
    role: "radio"
  })));
});

Option.propTypes = {
  isMultiSelect: _propTypes.bool.isRequired,
  disabled: _propTypes.bool,
  label: _propTypes.string.isRequired,
  selectedItems: (0, _propTypes.arrayOf)(_propTypes.node).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  Icon: _propTypes.any,
  image: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]),
  secondaryLabel: _propTypes.string,
  onClick: _propTypes.func,
  id: _propTypes.string,
  density: _propTypes.string
};
Option.defaultProps = {
  secondaryLabel: '',
  disabled: false,
  onClick: null,
  Icon: null,
  image: null,
  id: '',
  density: 'default'
};
var _default = Option;
exports.default = _default;